import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

ChartJS.defaults.font.family = "Nunito";
ChartJS.defaults.font.size = 10;

const DoughnutChartDB = ({ transactionType }) => {
  console.log(transactionType);

  const data = {
    labels: ["Paid", "On loan"],
    datasets: [
      {
        label: "Amount",
        data: transactionType,
        backgroundColor: ["#30A7EC", "rgb(204, 42, 99)" /* "#0F478C", "rgba(54, 162, 235, 1)" */ /* "#b3a000" */ /* "#D3D9A3" */],
        /*   borderColor: [
                          'rgba(255, 99, 132, 1)',
                          'rgba(54, 162, 235, 1)',
                          'rgba(255, 206, 86, 1)',
                          'rgba(75, 192, 192, 1)',
                          'rgba(153, 102, 255, 1)',
                          'rgb(191, 255, 64)',
                    ], */
        borderWidth: 1,
        cutout: 48,
        borderRadius: 10,
        hoverBackgroundColor: ["rgb(85, 184, 250)", "rgb(243, 78, 136)"],
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        display: false,
        position: "bottom",
        align: "start",
        labels: {
          boxWidth: 8,
        },
      },
      title: {
        display: false,
        text: "confiq.title",
      },
    },
  };
  return (
    <div className='DoughnutChart'>
      <Doughnut data={data} options={options} />
      <div className='don947563'>
        {/*   <p>16K</p>
       <p>16K</p> */}
      </div>
    </div>
  );
};

export default DoughnutChartDB;
